"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTextElementValidator = exports.createElementValidator = void 0;
const __1 = require("..");
const __2 = require("../../..");
const assertions_1 = require("./assertions");
const baseValidator = (propertyName, allowNil, predicate, failedPredicateError, sdkInstance) => {
    if (!sdkInstance) {
        if (allowNil) {
            return true;
        }
        __2.reportError(__2.messages.invalidTypeMessage({
            value: sdkInstance,
            types: ['object'],
            propertyName,
            functionName: `set ${propertyName}`,
            index: undefined,
        }));
        return false;
    }
    if (!predicate(sdkInstance)) {
        __2.reportError(failedPredicateError);
        return false;
    }
    return true;
};
const createElementValidator = (propertyName, allowNil = true) => (sdkInstance) => baseValidator(propertyName, allowNil, assertions_1.isElement, __1.getNotSelectorError(propertyName), sdkInstance);
exports.createElementValidator = createElementValidator;
const createTextElementValidator = (propertyName, allowNil = true) => (sdkInstance) => baseValidator(propertyName, allowNil, assertions_1.isTextElement, __1.getNotTextSelectorError(propertyName), sdkInstance);
exports.createTextElementValidator = createTextElementValidator;
//# sourceMappingURL=validators.js.map